import { Box } from '@chakra-ui/react';
import Spinner from 'components/Spinner';
import React from 'react';

const FallbackScreen: React.FC = () => {
  return (
    <Spinner loading={true}>
      <Box width={'100%'} height="100vh"></Box>
    </Spinner>
  );
};

export default FallbackScreen;
